import { useFormatNumber } from '../../../../../core/hooks/useFormatNumber'
import { useFormatAmount } from '../../../../../core/hooks/useFormatAmount'
import { useTranslation } from 'react-i18next'

interface GmvForecastGapLegendEntryProps {
  labelKey: string
  value: number
  comparisonBaseValue?: number
  currency: string
  iconColor: string
  iconBorder?: string
}

const GmvForecastGapLegendEntry = ({
  labelKey,
  value,
  comparisonBaseValue,
  currency,
  iconColor,
  iconBorder
}: GmvForecastGapLegendEntryProps) => {
  const { t } = useTranslation()
  const formatNumber = useFormatNumber()
  const formatAmount = useFormatAmount()

  const hasData = value !== null
  const hasComparisonData = hasData && comparisonBaseValue != null

  const getComparisonTextWithGap = (translationKey: string, value: number, comparisonBaseValue: number) => {
    const gmvTrajectoryGap = (value - comparisonBaseValue) / comparisonBaseValue
    const formattedGapPercentage = formatNumber(gmvTrajectoryGap, '', {
      style: 'percent',
      signDisplay: 'always',
      maximumFractionDigits: 1
    })

    return t(translationKey, {
      GAP: formattedGapPercentage
    })
  }

  return (
    <div className="mg-weekly-gmv-gap-chart-legend-entry" data-testid="entry">
      <div className="mg-weekly-gmv-gap-chart-legend-entry-title">
        <div
          className="mg-weekly-gmv-gap-chart-legend-entry-title-icon"
          data-testid="icon"
          style={{ backgroundColor: iconColor, border: iconBorder || 'none' }}
        />

        <div className="mg-weekly-gmv-gap-chart-legend-entry-title-label vp-caption" data-testid="label">
          {t(labelKey)}
        </div>
      </div>
      <div className="mg-weekly-gmv-gap-chart-legend-entry-data">
        <div
          className={`${hasData ? 'mg-weekly-gmv-gap-chart-legend-entry-data-value' : 'mg-weekly-gmv-gap-chart-legend-entry-data-value-no-data'} vp-caption`}
          data-testid="value"
        >
          {formatAmount(value, currency)}
        </div>

        {hasComparisonData && (
          <div
            className="mg-weekly-gmv-gap-chart-legend-entry-data-value-comparison vp-caption"
            data-testid="comparison"
          >
            {getComparisonTextWithGap(
              'general.homepage.weekly-gmv-forecast-gap.legend.gap-vs-trajectory',
              value,
              comparisonBaseValue
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default GmvForecastGapLegendEntry
